// watch for overlay open/close to lock body scroll
const scrollObserver = new MutationObserver(() => {
  const overlay = document.querySelector('cad-overlay, cad-overlay__container');
  if (overlay?.classList.contains('open')) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = '';
  }
});

scrollObserver.observe(document.querySelector('cad-overlay, cad-overlay__container') || document.body, {
  attributes: true,
  attributeFilter: ['class'],
  subtree: true
});

